import categoriesData from '../data/google_places_categories.json';

/**
 * Google Places API category mapping
 * Maps API identifiers (snake_case) to human-readable names
 */
export const GOOGLE_PLACES_CATEGORIES: Record<string, string> = categoriesData;

/**
 * Get human-readable name from Google Places API category ID
 */
export const getReadableCategoryName = (categoryId: string): string => {
  return GOOGLE_PLACES_CATEGORIES[categoryId] || categoryId;
};

/**
 * Get Google Places API category ID from human-readable name
 */
export const getCategoryIdFromReadable = (readableName: string): string => {
  const entry = Object.entries(GOOGLE_PLACES_CATEGORIES).find(
    ([_, value]) => value === readableName
  );
  return entry ? entry[0] : readableName;
};

/**
 * Get all categories as an array of {id, name} objects
 * Sorted alphabetically by human-readable name
 */
export const getAllCategories = (): Array<{ id: string; name: string }> => {
  return Object.entries(GOOGLE_PLACES_CATEGORIES)
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Check if a category ID exists in the mapping
 */
export const categoryExists = (categoryId: string): boolean => {
  return categoryId in GOOGLE_PLACES_CATEGORIES;
};
